import React, {
  useEffect,
  useState,
  useCallback,
  useLayoutEffect,
} from "react";
import { useNavigate } from "react-router-dom";
import "./BookingHistory.scss";
import Loader from "../../../components/Loader/Loader";
import { toast } from "react-toastify";
import NoGames from "../Comp/NoGames";
import NoBooking from "./NoBooking";

function BookingHistory() {
  const [bookingHistory, setBookingHistory] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  // Fetch booking history
  const fetchBookingHistory = useCallback(async () => {
    setLoading(true);
    const url = `https://ballersapi.ballerslife.co/api/v1/memberships/bookings/booking_history`;
    const accessToken = window.localStorage.getItem("access_token");

    try {
      const response = await fetch(url, {
        method: "GET",
        headers: {
          accept: "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
      });

      const data = await response.json();
      if (response.status === 200) {
        setBookingHistory(data.booking_history || []);
      } else if (response.status === 403) {
        window.localStorage.removeItem("access_token");
        window.localStorage.removeItem("flag");
        navigate("/login");
        window.location.reload();
      } else {
        // toast.error(data.detail || "Failed to fetch booking history.");
      }
    } catch (err) {
      // toast.error("An error occurred while fetching booking history.");
    } finally {
      setLoading(false);
    }
  }, [navigate]);

  // Set page title
  useEffect(() => {
    document.title = `Booking History | Ballers`;
  }, []);

  // Fetch booking history
  useEffect(() => {
    fetchBookingHistory();
  }, [fetchBookingHistory]);

  // Scroll to top only after loading is complete
  useLayoutEffect(() => {
    if (!loading) {
      const el = document.getElementById("scrollable-container");
      setTimeout(() => {
        if (el) {
          el.scrollTo({ top: 0, behavior: "smooth" });
        } else {
          window.scrollTo({ top: 0, behavior: "smooth" });
        }
      }, 100);
    }
  }, [loading]);

  // Handle back navigation
  const handleBack = () => {
    navigate(-1); // Navigate back to the previous page
  };
  const handleBookNow = () => {
    navigate("/dashboard/reserve");
  };

  return (
    <div className="booking-history" id="scrollable-container">
      <div className="header-container">
        <span className="back-icon" onClick={handleBack}>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            stroke="#FFB000"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <polyline points="15 18 9 12 15 6" />
          </svg>
        </span>
        <h2 className="section-title">BOOKING HISTORY</h2>
      </div>
      <div className="booking-list">
        {loading ? (
          <Loader />
        ) : bookingHistory.length > 0 ? (
          bookingHistory.map((booking, index) => (
            <div
              className="booking-entry"
              key={index}
              onClick={() =>
                navigate(`/dashboard/joingameDetails/${booking.booking_id}`)
              } // Navigate to the booking details page
              style={{ cursor: "pointer" }}
            >
              <div className="booking-detail">
                <span className="label">DATE:</span>
                <span className="value">{booking.booking_date}</span>
              </div>
              <div className="booking-detail">
                <span className="label">TIME:</span>
                <span className="value">{booking.booking_time}</span>
              </div>
              <div className="booking-detail">
                <span className="label">LOCATION:</span>
                <span className="value">{booking.facility_name}</span>
              </div>
              <div className="booking-detail">
                <span className="label">STATUS:</span>
                <span
                  className={`value bookingStatus ${booking.status
                    .toLowerCase()
                    .replace(/ /g, "-")}`} // Dynamically apply a class based on status
                  style={{
                    color:
                      booking.status.toLowerCase() === "completed" ||
                      booking.status.toLowerCase() === "confirmed" ||
                      booking.status.toLowerCase() === "checked-in"
                        ? "green"
                        : booking.status.toLowerCase() === "cancelled" ||
                          booking.status.toLowerCase() === "no show"
                        ? "red"
                        : booking.status.toLowerCase() === "pending"
                        ? "orange"
                        : "black", // Default color
                  }}
                >
                  {booking.status.charAt(0).toUpperCase() +
                    booking.status.slice(1)}
                </span>
              </div>
            </div>
          ))
        ) : (
          // <p className="no-bookings">No booking history found.</p>
          // <NoGames />
          <NoBooking />
        )}
      </div>
    </div>
  );
}

export default BookingHistory;
